/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { SearchResultOption } from 'src/components/settings/styles/select';

export const SearchGroupOption = styled(SearchResultOption)({
  padding: '1px 0',
  '& > div': {
    background: token('color.background.accent.gray.subtler'),
    borderRadius: '50%',
    border: `${token('space.025')} solid ${token('color.border.inverse')}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const DescriptionContainer = styled.div({
  marginBottom: token('space.300'),
  color: `#${token('color.text.accent.gray.bolder')}`,
});
